export const hashtagTextToLinkedInSearchLinkLib = (text: string): string => {
  return text.replace(
    /#(\w+)/g,
    `<a href="https://www.linkedin.com/search/results/all/?keywords=%23$1&origin=CORTIP" target="_blank">#$1</a>`
  )
}
